<template>
  <div>
    <b-button @click="openDialog" class="select-image">
      <b-icon-folder-plus aria-hidden="true"></b-icon-folder-plus>
      Select Image
    </b-button>

    <b-modal
      id="modal-image"
      title="Select Image"
      v-model="dialog">
      <b-tabs content-class="mt-3" v-model="tabIndex">
        <b-tab title="New" active>
          <ImageUpload :idx="0" />
        </b-tab>
        <b-tab title="Previous">
          <ImageExisting :idx="1" />
        </b-tab>
        <b-tab title="Library">
          <p :idx="2">Coming Soon! In the meantime,
            <a href="/shop/cap-library">visit our shop</a> for pre-designed images.</p>
        </b-tab>
      </b-tabs>
      <template v-slot:modal-footer>
        <b-button
            variant="primary"
            size=""
            class=""
            v-if="imageToSelect[tabIndex] && imageToSelect[tabIndex].key"
            @click="selectImage(tabIndex)">
          <b-icon-image aria-hidden="true"></b-icon-image>
          Use This Image
        </b-button>
        <b-button
            variant="secondary"
            size=""
            class=""
            @click="closeDialog">
          Close
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { BIconFolderPlus, BIconImage } from 'bootstrap-vue';

import ImageUpload from '@/components/ImageUpload.vue';
import ImageExisting from '@/components/ImageExisting.vue';

export default {
  name: 'ImageSelect',
  components: {
    BIconFolderPlus,
    BIconImage,
    ImageUpload,
    ImageExisting,
  },
  data() {
    return {
      dialog: false,
      tabIndex: 0,
    };
  },
  props: {
  },
  computed: {
    ...mapState(['imageToSelect']),
  },
  methods: {
    selectImage(idx) {
      // console.log('selectImage');
      const designparams = { image: this.imageToSelect[idx] };
      this.$store.commit('setDesign', designparams);
      this.$store.commit('clearImageToSelectAll');
      this.dialog = false;
      this.$emit('newImage');
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.$store.commit('clearImageToSelectAll');
      this.dialog = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select-image {
  margin-top: 45%;
}

</style>
